<template>
<div
    :class="[$style.sidebar, isSidebarOpen && $style.on]"
    @click.self="SET_SIDEBAR_OPEN(false)">
    <aside :class="$style.container">
        <app-sidebar-action />
        <app-sidebar-links />
    </aside>
</div>
</template>

<script>
import AppSidebarAction from "./AppSidebarAction.vue";
import AppSidebarLinks from "./AppSidebarLinks.vue";
import { mapGetters, mapMutations } from "vuex";

export default {
    components: { AppSidebarAction, AppSidebarLinks },
    computed: mapGetters(["isSidebarOpen"]),
    methods: mapMutations(["SET_SIDEBAR_OPEN"])
};
</script>

<style lang="scss" module>
@use "@/assets/scss/mixins" as m;

.sidebar {
    display: none;
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    left: 0;
    margin: 0;
    pointer-events: none;
    z-index: 7;
    @include m.lg {
        display: block;
    }

    &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        opacity: 0;
    }

    .container {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        transform: translate3d(100%, 0, 0);
        transition: transform 0.5s cubic-bezier(0, 0, 0.2, 1);
    }

    &.on {
        pointer-events: auto;
        &:before {
            transition: opacity 0.5s;
            opacity: 1;
        }
        .container {
            transform: translate3d(0, 0, 0);
            transition: transform 0.15s cubic-bezier(0.4, 0, 0.6, 1);
        }
    }
}
</style>
